<template>
<div v-if="isShow">
    <header>よくあるお問い合わせ<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
    </header>
    <div id="wrap">
        <div class="search-form-title">よくあるお問い合わせ</div>
        <div class="txt-area">
            <p>あああああああああああああああああああああああああああああああああああああああああああああ</p>
        </div>
        <div class="search-form-title">よくあるお問い合わせ</div>
        <div class="txt-area">
            <p>あああああああああああああああああああああああああああああああああああああああああああああ</p>
        </div>
        <div class="txt-area">
            <div class="btn4"><a href="config12a.html">その他のお問い合わせはこちら</a></div>
        </div>
    </div>
</div>
</template>

<script>
import {
  mapGetters
} from "vuex"
export default {
    props: {
        isShow: Boolean
    },
    emits: ['close'],
    computed: {
        ...mapGetters(["metadata", 'defaultToken']),
    },
}
</script>
